import { render } from "./individual.vue?vue&type=template&id=2d22b2f3&scoped=true"
import script from "./individual.vue?vue&type=script&lang=js"
export * from "./individual.vue?vue&type=script&lang=js"

import "./individual.vue?vue&type=style&index=0&id=2d22b2f3&lang=scss"
import "./individual.vue?vue&type=style&index=1&id=2d22b2f3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d22b2f3"]])

export default __exports__